import React, { useState } from 'react';
import { Tooltip, message } from 'antd';
import { AddAction, SmallP } from '../../../GarageAllocation/styled';
import SuccessModal from './components/SuccessModal';
import { sendRescheduleProposalRequest } from './api';
import AvailabilitySelectionModal from './components/AvailabilitySelectionModal';
import useGetActiveGarages from './hooks/useGetActiveGarages';
import useSyncLocalStorage from './hooks/useSyncLocalStorage';
import { getGarageAvailabilityToPrefill } from './logic/prefillAvailability';
import { StyledRescheduleButton } from './styled';
import rescheduleButtonIsDisabled from './logic/rescheduleButton';
import { getSubmissionErrors } from './logic/formValidation';
import config from '$config';

const RescheduleTriggerModal = ({ booking, garageInvites }) => {
  if (!config.featureFlags?.AUTO_RESCHEDULE_FLOW_ENABLED) return null;

  const [availabilityModalVisible, setAvailabilityModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [availabilitySubmitted, setAvailabilitySubmitted] = useState(false);
  const [garages, setGarages] = useState(null);
  const [errors, setErrors] = useState(null);

  const { bookingId } = booking;

  const localStorageKey = `rescheduleAvailability-${bookingId}`;
  const garageAvailabilityToPrefill = getGarageAvailabilityToPrefill(localStorageKey, garageInvites);

  const [rescheduleAvailabilityRows, setRescheduleAvailabilityRows] = useState(garageAvailabilityToPrefill);

  useGetActiveGarages(setGarages);
  useSyncLocalStorage(localStorageKey, rescheduleAvailabilityRows);

  // eslint-disable-next-line max-len
  if (booking.collectionDeliveryOption === 'CustomerC&D') return null; // This feature is not yet available for Cutstomer C&D;

  const showModal = () => setAvailabilityModalVisible(true);

  const sendRescheduleProposal = async () => {
    const submissionErrors = getSubmissionErrors(rescheduleAvailabilityRows);
    setErrors(submissionErrors);

    if (submissionErrors.length) return;

    setAvailabilitySubmitted(true);
    message.info('Sending reschedule request...');
    await sendRescheduleProposalRequest(bookingId, rescheduleAvailabilityRows);
    localStorage.removeItem(localStorageKey);
    setAvailabilityModalVisible(false);
    setSuccessModalVisible(true);
  };

  const RescheduleButton = ({ isDisabled }) => {
    if (isDisabled)
      return (
        <Tooltip title="Booking is already allocated or reschedule flow has been previously triggered">
          <StyledRescheduleButton className="disabled">
            <AddAction src="icon-add-circle-1">
              <SmallP>Reschedule</SmallP>
            </AddAction>
          </StyledRescheduleButton>
        </Tooltip>
      );
    return (
      <StyledRescheduleButton>
        <AddAction src="icon-add-circle-1" onClick={showModal}>
          <SmallP>Reschedule</SmallP>
        </AddAction>
      </StyledRescheduleButton>
    );
  };

  return (
    <>
      <RescheduleButton isDisabled={rescheduleButtonIsDisabled(booking.notes, booking.masterStatusId)} />

      <AvailabilitySelectionModal
        garages={garages}
        rescheduleAvailabilityRows={rescheduleAvailabilityRows}
        setRescheduleAvailabilityRows={setRescheduleAvailabilityRows}
        visible={availabilityModalVisible}
        setVisible={setAvailabilityModalVisible}
        sendRescheduleProposal={sendRescheduleProposal}
        errors={errors}
        availabilitySubmitted={availabilitySubmitted}
      />

      <SuccessModal visible={successModalVisible} />
    </>
  );
};

export default RescheduleTriggerModal;
